import React from "react";
import { StyledContactsSkeleton, StyledSkeletonItem } from "./index.styled";

interface ContactsSkeletonProps {
  count?: number;
}

const ContactsSkeleton: React.FC<ContactsSkeletonProps> = ({ count = 5 }) => {
  return (
    <StyledContactsSkeleton>
      {Array.from({ length: count }, (_, index) => (
        <StyledSkeletonItem key={index}>
          <div className="skeleton-avatar" />
          <div className="skeleton-content">
            <div className="skeleton-name" />
            <div className="skeleton-phone" />
          </div>
          <div className="skeleton-date">
            <div className="skeleton-source" />
            <div className="skeleton-join-date" />
          </div>
        </StyledSkeletonItem>
      ))}
    </StyledContactsSkeleton>
  );
};

export default ContactsSkeleton;
